import { render, staticRenderFns } from "./BetSlipLoad.vue?vue&type=template&id=470b4f64&scoped=true&"
import script from "./BetSlipLoad.vue?vue&type=script&lang=js&"
export * from "./BetSlipLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b4f64",
  null
  
)

export default component.exports